var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _vm.isNav
        ? _c(
            "el-header",
            { staticClass: "fixed-head" },
            [_c("CommonHeaderGuoJiao")],
            1
          )
        : _vm._e(),
      _c("el-main", { class: { nav: _vm.isNav } }, [_c("router-view")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }